document.querySelectorAll('.lang-selector').forEach(selector => {
  selector.addEventListener('click', event => {
    const currentSelector = event.currentTarget;
    const bodyElement = currentSelector.querySelector('.lang-selector__body');
    const icon = currentSelector.querySelector('.lang-selector__chevron-down');
    if (bodyElement) {
      bodyElement.classList.toggle('lang-selector__body--is-open');
    }
    if (icon) {
      icon.classList.toggle('lang-selector__chevron-down--is-active');
    }
  });
});

// Ajoute un seul écouteur de clic sur document pour gérer la fermeture
document.addEventListener('click', e => {
  document.querySelectorAll('.lang-selector').forEach(selector => {
    const bodyElement = selector.querySelector('.lang-selector__body');
    const icon = selector.querySelector('.lang-selector__chevron-down');
    if (!selector.contains(e.target)) {
      bodyElement?.classList.remove('lang-selector__body--is-open');
      icon?.classList.remove('lang-selector__chevron-down--is-active');
    }
  });
});